// locale selectors
import { createSelector } from "reselect";
import * as locale from "../reducers/locale.reducer";
import * as auth from "../reducers/auth.reducer";
import * as cookieMessage from "../reducers/cookieMessage.reducer";
import * as deviceInfo from "../reducers/device-info.reducer";

export const getLocaleState = state => state.locale;
export const getLanguage = createSelector(getLocaleState, locale.getLanguage);
export const getRegion = createSelector(getLocaleState, locale.getRegion);
export const getLocaleString = createSelector(
  getLanguage,
  getRegion,
  (language, region) => `${language}_${region.toUpperCase()}`
);
export const getAvailableLocales = createSelector(
  getLocaleState,
  locale.getAvailableLocales
);

export const getAuthState = state => state.auth;
export const isAuthenticated = createSelector(
  getAuthState,
  auth.isAuthenticated
);

export const getCookieMessageState = state => state.cookieMessage;
export const isCookieMessageOpen = createSelector(
  getCookieMessageState,
  cookieMessage.isOpen
);
export const isCookieMessageSettingsOpen = createSelector(
  getCookieMessageState,
  cookieMessage.isSettingsOpen
);
export const isCookieMessageClosable = createSelector(
  getCookieMessageState,
  cookieMessage.isClosable
);

export const getSelectedCookie = createSelector(
  getCookieMessageState,
  cookieMessage.getSelectedCookie
);

export const getDeviceInfoState = state => state.deviceInfo;
export const getDeviceType = createSelector(
  getDeviceInfoState,
  deviceInfo.getDeviceType
);
